import filestackFactory from '@scoir/filestack'
export { fileExtensions, defaultPickerOptions } from '@scoir/filestack'

export default filestackFactory(window.FILE_STACK_KEY, window.filepicker || { setKey: () => {} })
